<template>
  <Layout :stylex="{paddingLeft: '320px'}">
    <Content
      :style="{ backgroundColor: '#fff', minHeightx: '600px', width: '100%', marginTop: '60px', marginBottomXXXForFotter: '100px', padding: '20px 25px'}" >
      <Monitoring></Monitoring>
    </Content>
  </Layout>
</template>

<script>
import Monitoring from "../components/Monitoring.vue";

export default {
  components: {
    Monitoring
  }
};
</script>